import { render, staticRenderFns } from "./AiChatDialog.vue?vue&type=template&id=6edc553f&scoped=true"
import script from "./AiChatDialog.vue?vue&type=script&lang=js"
export * from "./AiChatDialog.vue?vue&type=script&lang=js"
import style0 from "./AiChatDialog.vue?vue&type=style&index=0&id=6edc553f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc553f",
  null
  
)

export default component.exports